exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".news-summary {\n  background: #0e141d; }\n  .news-summary img {\n    width: 100%;\n    border: 0; }\n\n@media screen and (min-width: 1920px) {\n  .news-summary .imgs-wrapper {\n    text-align: center; }\n    .news-summary .imgs-wrapper .text-img {\n      width: 1920px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/pages/news/index.scss
// module id = 648
// module chunks = 0